import {
  Homepage,
  SsoCallbackPage,
  DashboardPage,
  ProjectListPage,
  EpicListPage,
  SprintListPage,
  BacklogPage,
  BoardPage,
  TaskDetailPage,
  TimesheetPage,
  ReportsPage,
  TicketListPage,
  TicketDetailPage,
  UserListPage,
  SettingsPage,
} from "../../pages";
import { SessionUser } from "../../types/interfaces";

const INTERNAL_ROLES: SessionUser["role"][] = ["manager", "agent"];
// managers only
const ADMIN_ROLES: SessionUser["role"][] = ["manager"];

export const routes = {
  home: "/",
  ssoCallback: "/auth/callback",
  dashboard: "/dashboard",
  projects: "/projects",
  projectBoard: "/projects/:id/board",
  projectBacklog: "/projects/:id/backlog",
  projectEpics: "/projects/:id/epics",
  backlog: "/backlog",
  sprints: "/sprints",
  taskDetail: "/tasks/:id",
  myTime: "/my-time",
  reports: "/reports",
  adminUsers: "/admin/users",
  settings: "/admin/settings",
  tickets: "/support",
  ticketDetail: "/support/tickets/:id",
};

export const Pages = [
  { path: routes.home, protected: false, component: <Homepage /> },
  { path: routes.ssoCallback, protected: false, component: <SsoCallbackPage /> },
  { path: routes.dashboard, protected: true, component: <DashboardPage /> },
  { path: routes.projects, protected: true, component: <ProjectListPage /> },
  { path: routes.projectBoard, protected: true, roles: INTERNAL_ROLES, component: <BoardPage /> },
  { path: routes.projectBacklog, protected: true, roles: INTERNAL_ROLES, component: <BacklogPage /> },
  { path: routes.projectEpics, protected: true, roles: INTERNAL_ROLES, component: <EpicListPage /> },
  { path: routes.backlog, protected: true, roles: INTERNAL_ROLES, component: <BacklogPage /> },
  { path: routes.sprints, protected: true, roles: INTERNAL_ROLES, component: <SprintListPage /> },
  { path: routes.taskDetail, protected: true, roles: INTERNAL_ROLES, component: <TaskDetailPage /> },
  { path: routes.myTime, protected: true, roles: INTERNAL_ROLES, component: <TimesheetPage /> },
  { path: routes.reports, protected: true, roles: ADMIN_ROLES, component: <ReportsPage /> },
  { path: routes.adminUsers, protected: true, roles: ADMIN_ROLES, component: <UserListPage /> },
  { path: routes.settings, protected: true, roles: ADMIN_ROLES, component: <SettingsPage /> },
  { path: routes.tickets, protected: true, component: <TicketListPage /> },
  { path: routes.ticketDetail, protected: true, component: <TicketDetailPage /> },
];
